import { render, staticRenderFns } from "./review-component-image.vue?vue&type=template&id=59cde110&scoped=true"
import script from "./review-component-image.vue?vue&type=script&lang=js"
export * from "./review-component-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cde110",
  null
  
)

export default component.exports